module.exports = __webpack_public_path__ + "img/cooperation.d150e4d5.png";